import { db, storage } from "./config"
import { collection, addDoc, getDocs, query, where, doc, updateDoc, getDoc, deleteDoc } from "firebase/firestore"
import { getDownloadURL, ref, uploadBytes } from "firebase/storage"

export const createBoxType = async (label, value) => {
    try {
        // Reference to the "boxTypes" collection
        const boxTypesRef = collection(db, "boxTypes")

        // Add a new document with a generated ID
        const docRef = await addDoc(boxTypesRef, {
            label: label,
            value: value,
            created_at: new Date(),
            state: 'active'
        })

        console.log("Document written with ID: ", docRef.id)
    } catch (e) {
        console.error("Error adding document: ", e)
    }
}

export const updateBoxType = async (updatedData) => {
    try {
        // Reference to the specific box type document
        const boxTypeRef = doc(db, "boxTypes", updatedData.id)
        const boxTypeSnapshot = await getDoc(boxTypeRef)
        const boxTypeData = boxTypeSnapshot.data()

        const newData = {
            label: updatedData.label,
            value: updatedData.value,
            state: updatedData.state ? updatedData.state : boxTypeData.state
        }

        // Update the document with new data
        await updateDoc(boxTypeRef, newData)

        console.log("Document updated with ID: ", updatedData.id)
    } catch (e) {
        console.error("Error updating document: ", e)
    }
}

export const deleteBoxType = async (boxTypeId) => {
    try {
        // Reference to the specific box type document
        const boxTypeRef = doc(db, "boxTypes", boxTypeId);

        // Delete the document
        await deleteDoc(boxTypeRef);

        console.log("Document deleted with ID: ", boxTypeId);
    } catch (e) {
        console.error("Error deleting document: ", e);
    }
}

export const getAllBoxTypes = async (states = ["active"]) => {
    try {
        // Reference to the "boxTypes" collection
        const boxTypesRef = collection(db, "boxTypes")

        const boxTypes = []

        // Create a query to filter box types by state
        for (let state of states) {
            const q = query(boxTypesRef, where("state", "==", state))
            const querySnapshot = await getDocs(q)
            querySnapshot.forEach(async (doc) => {
                boxTypes.push({ id: doc.id, ...doc.data() })
            })
        }

        // Sort by created_at in descending order (newest first)
        boxTypes.sort((a, b) => {
            const dateA = a.created_at && a.created_at.seconds ? new Date(a.created_at.seconds * 1000) : new Date(0)
            const dateB = b.created_at && b.created_at.seconds ? new Date(b.created_at.seconds * 1000) : new Date(0)
            return dateB - dateA
        })

        return boxTypes // Return the sorted array of box types
    } catch (e) {
        console.error("Error getting documents: ", e)
        return [] // Return an empty array in case of error
    }
}

export const getBoxTypeById = async (boxTypeId) => {
    try {
        // Reference to the "boxTypes" collection
        const boxTypeRef = doc(db, "boxTypes", boxTypeId)
        const querySnapshot = await getDoc(boxTypeRef)

        return querySnapshot.data()
    } catch (e) {
        console.error("Error getting box type: ", e)
        return null // Return null in case of error
    }
}

export const checkBoxTypeExists = async (boxTypeLabel) => {
    try {
        const boxTypesRef = collection(db, "boxTypes")
        const q = query(boxTypesRef, where("label", "==", boxTypeLabel))
        const querySnapshot = await getDocs(q)

        if (!querySnapshot.empty) {
            return true // Box type exists
        } else {
            return false // Box type does not exist
        }
    } catch (error) {
        console.error("Error checking box type:", error)
    }
}

export const addCreatedAtToExistingBoxTypes = async () => {
    try {
        const boxTypesRef = collection(db, "boxTypes")
        const querySnapshot = await getDocs(boxTypesRef)
        
        const updatePromises = []
        
        querySnapshot.forEach((doc) => {
            const data = doc.data()
            if (!data.created_at) {
                const boxTypeRef = doc(db, "boxTypes", doc.id)
                updatePromises.push(
                    updateDoc(boxTypeRef, {
                        created_at: new Date()
                    })
                )
            }
        })
        
        if (updatePromises.length > 0) {
            await Promise.all(updatePromises)
            console.log(`Updated ${updatePromises.length} box types with created_at`)
        }
    } catch (error) {
        console.error("Error adding created_at to existing box types:", error)
    }
} 